// extracted by mini-css-extract-plugin
module.exports = {"apply":"apply--2w08E","btns":"btns--2jpPx","saveBtn":"saveBtn--27BjN","boxTitle":"boxTitle--WGjEA","info":"info--2Pffc","high":"high--yCQFL","editor":"editor--zklwn"};